import * as React from 'react';
import styled from '@emotion/styled';
import css from '@styled-system/css';
import _shouldForwardProp from '@styled-system/should-forward-prop';

var getSx = function getSx(props) {
  return css(props._sx)(props.theme);
};

var wrapGetBaseStyle = function wrapGetBaseStyle(_getBaseStyle) {
  return function (props) {
    if (!_getBaseStyle) {
      return;
    }

    return css(_getBaseStyle(props))(props.theme);
  };
};

export var getBox = function getBox(getBaseStyle, excludedProps) {
  var _getBaseStyle = wrapGetBaseStyle(getBaseStyle);

  return styled('div', {
    shouldForwardProp: function shouldForwardProp(prop) {
      if (!_shouldForwardProp(prop)) {
        return false;
      }

      if (excludedProps && excludedProps.includes(prop)) {
        return false;
      }

      return true;
    }
  })(_getBaseStyle, getSx);
};
export default getBox;